import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import CaseVouchers from '../economy/case-vouchers/CaseVouchers.js';
import { Panel } from '../index.js';
import HistItem from './HistItem.js';
const EconomyItem = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    return (React.createElement(HistItem, { date: props.historyItem.date, timespan: props.historyItem.timespan, heading: lang.economy.histItemHeader },
        React.createElement(Panel, null, singleCase && (React.createElement(CaseVouchers, { singleCase: singleCase, caseVouchers: props.historyItem.data.caseVouchers })))));
};
export default EconomyItem;
//# sourceMappingURL=EconomyItem.js.map